export const availableRoles = [
  { name: 'admin', label: 'amministratore' },
  { name: 'investor', label: 'investitore' },
  { name: 'consultant', label: 'supervisor' },
  { name: 'owner', label: 'proprietario' },
  { name: 'manager', label: 'manager' },
  { name: 'visitor', label: 'visitatore' },
];

export default function (role) {
  const roleFound = availableRoles.find(r => r.name === role.toLowerCase());

  if (typeof roleFound === 'undefined') {
    return '';
  }

  return roleFound.label;
};
